import {getFormattedFullLocation} from '@wix/wix-events-commons-statics'
import React from 'react'
import classNames from 'classnames'
import {EventImage} from '../../../../../event-image'
import {LinkToPage} from '../../../../../link-to-page'
import {Members} from '../../../../../members'
import {Ribbon} from '../../../../../ribbon'
import {RsvpButton} from '../../../../../rsvp-button'
import {SocialBar} from '../../../../../social-bar'
import {PopupHeader} from '../header'
import s from './monthly-calendar-event-details.scss'
import {MonthlyCalendarEventDetailsProps} from '.'

export class MonthlyCalendarEventDetails extends React.PureComponent<MonthlyCalendarEventDetailsProps> {
  onBack = () => this.props.closeMonthlyCalendarEvent()

  render() {
    const {
      dateText,
      event,
      dayEventCount,
      showImage,
      showFullDate,
      showLocation,
      showDescription,
      showShare,
      showMembers,
      fullDate,
      shareFontSize,
      imagePosition,
      squareImage,
      closeMonthlyCalendarPopup,
      t,
      showRibbon,
    } = this.props

    return (
      <div className={s.container} data-hook="calendar-event-details">
        <PopupHeader
          eventDetails
          text={dateText}
          onClose={closeMonthlyCalendarPopup}
          onBack={dayEventCount > 1 ? this.onBack : undefined}
          t={t}
        />
        <div className={s.eventDetailsContent}>
          {showImage ? (
            <div className={classNames(s.image, squareImage ? s.squareRatio : s.wideRatio)}>
              <EventImage event={event} position={imagePosition} noLQIP />
            </div>
          ) : null}
          {showRibbon ? <Ribbon event={event} className={s.ribbon} calendar /> : null}
          <div className={s.title} data-hook="title">
            <LinkToPage event={event}>{event.title}</LinkToPage>
          </div>
          {showFullDate ? (
            <div className={s.fullDate} data-hook="date">
              {fullDate}
            </div>
          ) : null}
          {showLocation ? (
            <div className={s.location} data-hook="location">
              {getFormattedFullLocation(event)}
            </div>
          ) : null}
          {showMembers ? (
            <div className={s.members} data-hook="members">
              <Members event={event} calendarLayout={true} />
            </div>
          ) : null}
          {showDescription && event.description ? (
            <div className={s.description} data-hook="description">
              {event.description}
            </div>
          ) : null}
          {showShare ? (
            <div className={s.share} data-hook="share">
              <div className={s.shareText}>{t('shareEventText')}</div>
              <SocialBar t={t} spacing={7} event={event} iconFontSize={shareFontSize} row hideTitle />
            </div>
          ) : null}
        </div>
        <div className={s.button}>
          <RsvpButton event={event} dataHook="rsvp-button" minWidth={88} additionalStyle={{minHeight: 32}} />
        </div>
      </div>
    )
  }
}
